<template>
  <section class="editor-widget">
    <vue-editor v-model="content" :editorToolbar="customToolbar"></vue-editor>
  </section>
</template>

<script lang="js">
import { VueEditor,Quill } from "vue2-editor";
import PlainTextClipboard from 'quill-plain-text-paste'

var toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],
  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
  [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
  [{ 'direction': 'rtl' }],                         // text direction
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
  [{ 'align': [] }]                                       // remove formatting button
];


export default {
    components: { VueEditor },
    name: 'veditor',
    props: {
      value: {
                type: String,
                default: ''
            }
    },
    mounted() {
        Quill.register(Quill.import('attributors/style/direction'), true);
        Quill.register(Quill.import('attributors/style/align'), true);
        Quill.register('modules/clipboard', PlainTextClipboard);
        this.content = this.value 
    },
    data() {
        return {
           content:"",
           customToolbar: toolbarOptions
        }
    },
    methods: {
        updateValue(value) {
          this.$emit("input", value);
        }
    },
    watch: {
      value:function (val) {
        let vm = this;
          vm.content = val;
      },
      content:function (val) {
        this.updateValue(val)
      }
    },
}
</script>

<style scoped lang="scss">
.editor-widget {
  background: #fff;
}
</style>
